/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as OfferSlugIndexRouteImport } from "./routes/$offerSlug/index"

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const OfferSlugIndexRoute = OfferSlugIndexRouteImport.update({
  id: "/$offerSlug/",
  path: "/$offerSlug/",
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/$offerSlug/": typeof OfferSlugIndexRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/$offerSlug": typeof OfferSlugIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/$offerSlug/": typeof OfferSlugIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: "/" | "/$offerSlug/"
  fileRoutesByTo: FileRoutesByTo
  to: "/" | "/$offerSlug"
  id: "__root__" | "/" | "/$offerSlug/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  OfferSlugIndexRoute: typeof OfferSlugIndexRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/$offerSlug/": {
      id: "/$offerSlug/"
      path: "/$offerSlug"
      fullPath: "/$offerSlug/"
      preLoaderRoute: typeof OfferSlugIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  OfferSlugIndexRoute: OfferSlugIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
